import { EnrolmentRoute } from "@/constants/routes/enrolment"
import { onBeforeUnmount, onMounted, watch } from "vue"
import { useRoute } from "vue-router"

import { useEnrolment } from "./useEnrolment"

export const TrackingScripts = {
  TANGO: {
    BASKET: `window.data_8892 = []; window.data_8892.push({ 'Currency': '$Currency$', 'CustomerType': '$CustomerType$', 'ProductId': '$ProductId$', 'gdpr': '\${GDPR}', 'gdpr_consent': '\${GDPR_CONSENT_962}', 'gdpr_pd': '\${GDPR_PD}', 'us_privacy': '\${US_PRIVACY}', 'PageType': 'basket' }); (function(d) { var s_tangoo = d.createElement('script'); s_tangoo.async = true; s_tangoo.id = 'DLFNPMMP1'; s_tangoo.type = 'text/javascript'; s_tangoo.src = 'https://cdn.tangoo.it/aud/clientjs/ptag.js?8892'; var a_tangoo = d.getElementsByTagName('script')[0]; a_tangoo.parentNode.insertBefore(s_tangoo, a_tangoo); if (typeof LB8892 !== 'undefined') { LB8892.init(window.data_8892[0]); } }(document));`,
    CHECKOUT: `window.data_8892 = []; window.data_8892.push({ 'OrderId': '$OrderId$', 'Amount': '$Amount$', 'Currency': '$Currency$', 'CustomerType': '$CustomerType$', 'ProductId': '$ProductId$', 'gdpr': '\${GDPR}', 'gdpr_consent': '\${GDPR_CONSENT_962}', 'gdpr_pd': '\${GDPR_PD}', 'us_privacy': '\${US_PRIVACY}', 'PageType': 'checkout' }); (function(d) { var s_tangoo = d.createElement('script'); s_tangoo.async = true; s_tangoo.id = 'DLFNPMMP1'; s_tangoo.type = 'text/javascript'; s_tangoo.src = 'https://cdn.tangoo.it/aud/clientjs/ptag.js?8892'; var a_tangoo = d.getElementsByTagName('script')[0]; a_tangoo.parentNode.insertBefore(s_tangoo, a_tangoo); if (typeof LB8892 !== 'undefined') { LB8892.init(window.data_8892[0]); } }(document));`,
  },
  BANNER_CROWD: `(function (b, n, r, c, w, d) { c = "B669OB"; w = b.createElement(n); w.async = 1; w.src = "//collect.bannercrowd.net/js?id=" + c; d = b.getElementsByTagName(n)[0]; function x(y, z) { y.parentNode.insertBefore(z, y) } b.readyState != "loading" ? x(d, w) : b.addEventListener ? r.addEventListener("load", x(d, w)) : b.attachEvent && r.attachEvent("onload", x(d, w)) })(document, "script", window);`,
  SWAYER: `//tagsrv.swayer.io/events?gaq=n1E97n`,
}

function createScript({
  hid,
  innerHTML,
  src,
  async = false,
  type = "text/javascript",
}: {
  hid: string
  innerHTML?: string
  src?: string
  async?: boolean
  type?: string
}) {
  const existingScript = document.getElementById(hid)

  if (existingScript) existingScript.remove()

  const script = document.createElement("script")
  script.id = hid
  script.type = type

  if (innerHTML) script.innerHTML = innerHTML
  if (src) script.src = src
  if (async) script.async = true

  document.head.appendChild(script)
}

export const useEnrolmentAffiliateTracking = () => {
  const route = useRoute()
  const { tariff, enrolmentId } = useEnrolment()

  onMounted(() => {
    createScript({
      hid: "banner-crowd",
      innerHTML: TrackingScripts.BANNER_CROWD,
    })
    createScript({
      hid: "swayer",
      src: TrackingScripts.SWAYER,
      async: true,
    })
  })

  watch(
    [() => route.path, () => tariff.value.quoteId, enrolmentId],
    () => {
      const amount = tariff.value?.elecAnnualCostInPounds?.toString() ?? ""
      const productId = tariff.value?.tariffName ?? ""

      const privacyVars = {
        gdpr: "0",
        gdpr_consent: "0",
        gdpr_pd: "1",
        us_privacy: "1---",
      }

      let scriptContent = TrackingScripts.TANGO.CHECKOUT
      let hid = "tangoo-checkout"

      if (route.path === EnrolmentRoute.enrolmentReview) {
        if (!enrolmentId.value) return

        scriptContent = scriptContent
          .replace("$OrderId$", enrolmentId.value.toString())
          .replace("$Amount$", amount)
      } else {
        scriptContent = TrackingScripts.TANGO.BASKET
        hid = "tangoo-basket"
      }

      scriptContent = scriptContent
        .replace("$Currency$", "GBP")
        .replace("$CustomerType$", "new")
        .replace("$ProductId$", productId)
        .replace("${GDPR}", privacyVars.gdpr)
        .replace("${GDPR_CONSENT_962}", privacyVars.gdpr_consent)
        .replace("${GDPR_PD}", privacyVars.gdpr_pd)
        .replace("${US_PRIVACY}", privacyVars.us_privacy)

      createScript({
        hid,
        innerHTML: scriptContent,
      })
    },
    { immediate: true },
  )

  onBeforeUnmount(() => {
    ;["banner-crowd", "swayer", "tangoo-checkout", "tangoo-basket"].forEach(
      (scriptId) => {
        const existingScript = document.getElementById(scriptId)

        if (existingScript) {
          existingScript.remove()
        }
      },
    )
  })
}
